import execoraImage from '../images/coustomers/execora.png';
import shekonomiImage from '../images/coustomers/shekonomi.png';
import riktigtrentImage from '../images/coustomers/riktigtrent.png';
import opheliaImage from '../images/coustomers/ophelia.png';
import mazenImage from '../images/coustomers/mazen.png';
import threesoftImage from '../images/coustomers/Threesoft.png';
import gmsImage from '../images/coustomers/gms.png';
import husqvarnaImage from '../images/coustomers/husqvarna.png';

const projectsData = [
  {
    title: 'Execora.se',
    image: execoraImage,
    description:
      'Webbdesign, utveckling och Teamtailor. Designade och utvecklade en modern, tvåspråkig företagswebbplats för ett konsultbolag inom kompetensförsörjning. Fokus låg på UX/UI, tydliga CTA-flöden och att förmedla ett professionellt budskap mot både kandidater och företag. Byggde sidan i React med JavaScript och CSS samt arbetade även i Teamtailor med design och integration av rekryteringsflöden. Integrerade även CookieScript, reCAPTCHA och EmailJS för formulär, säkerhet och funktionalitet. Levererad via Miss Hosting.',
    review:
      '"Arya är en väldigt trevlig och professionell person som är lätt att samarbeta med. Under tiden han arbetade med att fixa min hemsida execora.se har han varit både flexibel, lyhörd och engagerad. Jag är mycket nöjd med resultatet och kan varmt rekommendera honom."',
    reviewer: 'Mohamad Najib, CEO',
    link: 'https://execora.se/',
  },
  {
    title: 'Shekonomi',
    image: shekonomiImage,
    description:
      'Byggde en modern digital plattform med React, JavaScript och Supabase med fokus på låg driftskostnad, tydlig visuell profil och skalbar struktur.',
    review:
      '"Jag kan verkligen rekommendera Arya! Han gjorde ett fantastiskt jobb med min hemsida shekonomi.com. Allt gick snabbt och smidigt, och han var otroligt lyhörd och tålmodig genom hela processen. Jag är mer än nöjd med resultatet!"',
    reviewer: 'Samia Herbaz, CEO',
    link: 'https://shekonomi.com/',
  },
  {
    title: 'Riktigt Rent',
    image: riktigtrentImage,
    description:
      'Lyfte ett lokalt städföretag till digital närvaro med en varm, lättnavigerad webb och inbyggd prisberäkning för offert i realtid.',
    review:
      '"Jag rekommenderar starkt Arya. Han är väldigt noggrann och anpassar sitt arbete efter kundens behov. Han är kreativ och skapar framgångsrikt hemsidor."',
    reviewer: 'Jasna Abuzaid, CEO',
    link: 'https://riktigtrent.com/',
  },
  {
    title: 'Ophelia AI',
    image: opheliaImage,
    description:
      'Ledde projektet agilt från forskningsidé till produktionssatt AI-lösning för riskbedömning inom våld i nära relation, med flera utmärkelser på vägen.',
    
    link: 'https://www.opheliaai.se/',
  },
  {
    title: 'Mazen Barbershop',
    image: mazenImage,
    description:
      'Utvecklade en kundanpassad webb för nederländsk barbershop i React, med tydlig konverteringsyta och stark varumärkeskänsla.',
    review: '',
    reviewer: '',
    link: 'https://mazenbarbershop.netlify.app/',
  },
  {
    title: 'Threesoft AB',
    image: threesoftImage,
    description:
      'Var med och byggde upp Threesoft AB från grunden tillsammans med två andra utvecklare, med fokus på kunduppdrag inom webb och app.',
    review: '',
    reviewer: '',
    link: 'https://threesoft.se/',
  },
  {
    title: 'GM Säkerhet',
    image: gmsImage,
    description:
      'Byggde en tydlig och förtroendeskapande React-webb för ett snabbt växande bevakningsföretag i Norrland som ville stärka sin digitala närvaro.',
    review: '',
    reviewer: '',
    link: '',
  },
  {
    title: 'Husqvarna Internship',
    image: husqvarnaImage,
    description:
      'Under praktikperiod utvecklade jag en Kotlin-lösning med BLE där enheter kunde signalera mellan varandra vid statusförändringar, i samarbete med hårdvaruingenjör.',
    review: '',
    reviewer: '',
    link: '',
  },
];

export default projectsData;
